import {defineStore} from 'pinia'
import appNotificationService from "src/services/utils/appNotificationService";
import {usePappusAiStore} from "./pappusAiStore";

const name = 'auth'
// Utilisateur auquel appartient la conversation Pappus gardée sur cet appareil
const AI_OWNER_KEY = 'pappusAi.owner'

const user = JSON.parse(localStorage.getItem("user"));

const initialState = user ? { status: { loggedIn: true }, user : user } :  { status: { loggedIn: false }, user: null }

export const useAuthStore = defineStore(name,{

  id: name,

  state: () => (initialState),

  actions: {

    grantAccess(access) {
      console.log("Grant access :"+ access)
      this.status.loggedIn = access
    },
    login(user) {
      // Un autre utilisateur se connecte sur ce navigateur : la conversation Pappus du précédent n'est pas reprise
      const owner = localStorage.getItem(AI_OWNER_KEY)
      if (owner && owner !== String(user.id)) usePappusAiStore().reset()
      localStorage.setItem(AI_OWNER_KEY, String(user.id))
      localStorage.setItem("user", JSON.stringify(user));
      this.status.loggedIn = true;
      this.user = user;
    },
    logout() {
      // Fin de la session dans le journal des connexions (sans attendre ni bloquer)
      const token = this.user && this.user.accessToken
      if (token) {
        import("src/services/utils/appEnvService").then(({default: AppEnvService}) =>
          fetch(`${AppEnvService.getEnv("APP_PROTOCOL")}://${AppEnvService.getEnv("APP_DOMAIN")}/api/auth/signout`,
            {method: 'POST', headers: {'x-access-token': token}}))
          .catch(() => {})
      }
      this.status.loggedIn = false
      this.user = undefined
      localStorage.setItem("user", null);
      // La conversation Pappus ne reste pas sur l'appareil (elle est enregistrée sur le serveur)
      usePappusAiStore().reset()
      localStorage.removeItem(AI_OWNER_KEY)
    },
    /** Outils de prix activés ou désactivés (sa propre fiche, ou refus du serveur) : tous les écrans suivent */
    setPriceTools(value) {
      if (!this.user) return;
      this.user = {...this.user, priceTools: !!value};
      localStorage.setItem("user", JSON.stringify(this.user));
    },
    register(user) {
      localStorage.setItem("user", JSON.stringify(user));
      this.status.loggedIn = true;
      this.user = user;
      appNotificationService.pushInfo("[register] "+ this.user.username)
    }

  },
  getters: {
    isLoggedIn:  (state) =>  {
      return state.status.loggedIn;
    },
    currentUser:  (state) =>  {
      if (state.status.loggedIn) {
        return state.user;
      } else {
        return null;
      }
    },
    currentGeo:(state)=>{
      if (state.status.loggedIn) {
        if(state.user && state.user.geo){
          return {lat: state.user.geo.lat, lng: state.user.geo.lng}
        }
      }
      return {lat: 0, lng: 0}
    },
  }

})
